/**
 * THE CROSS-PAGE LINK TO A HEALTH FILTER (common brief, "Cross-page URL contract"):
 * `/fulfillment/clients?health=red|yellow|green` opens Clients with that Health filter set.
 * FE-CLIENTS reads the parameter, FE-DASHBOARD links to it (open question Q-DB-13: the tile
 * opens Clients filtered to Needs attention).
 */
export type HealthFilter = 'red' | 'yellow' | 'green';

export const CLIENTS_PATH = '/fulfillment/clients';
export const HEALTH_PARAM = 'health';

export function clientsHref(options: { readonly health?: HealthFilter | undefined } = {}): string {
  return options.health === undefined
    ? CLIENTS_PATH
    : `${CLIENTS_PATH}?${HEALTH_PARAM}=${options.health}`;
}

/** The reading half, for the Clients page: an unknown value is no filter. */
export function healthFilterOf(search: string | URLSearchParams): HealthFilter | null {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const value = params.get(HEALTH_PARAM);
  return value === 'red' || value === 'yellow' || value === 'green' ? value : null;
}

/** The client page of one agency (the path `ClientsPage.tsx` already builds). */
export function clientHref(agencyId: string): string {
  return `${CLIENTS_PATH}/${agencyId}`;
}
